import type { Fiche, TemplateId } from '@pharmafiche/schema';
import type { ComponentType } from 'react';
import { FicheClinique } from './FicheClinique';
import { FicheComparative } from './FicheComparative';
import type { FicheEditHandlers } from './FicheDessinee';
import { FicheDessinee } from './FicheDessinee';
import { FicheFlowchart } from './FicheFlowchart';
import { FicheInfographique } from './FicheInfographique';
import { FicheMinimaliste } from './FicheMinimaliste';

export interface TemplateProps {
  fiche: Fiche;
  editHandlers?: FicheEditHandlers;
}

export interface TemplateMeta {
  id: TemplateId;
  label: string;
  vibe: string;
  Component: ComponentType<TemplateProps>;
}

/** Ordered list of templates surfaced in the picker. */
export const TEMPLATES: TemplateMeta[] = [
  {
    id: 'dessinee',
    label: 'Dessinée',
    vibe: 'Notes manuscrites, cartes inclinées, papier quadrillé',
    Component: FicheDessinee,
  },
  {
    id: 'clinique',
    label: 'Clinique',
    vibe: 'Protocole hospitalier, sobriété éditoriale',
    Component: FicheClinique,
  },
  {
    id: 'infographique',
    label: 'Infographique',
    vibe: 'Magazine, chiffres en gros, tons pastel',
    Component: FicheInfographique,
  },
  {
    id: 'comparative',
    label: 'Comparative',
    vibe: 'Tableau central, comparaison de molécules',
    Component: FicheComparative,
  },
  {
    id: 'flowchart',
    label: 'Flowchart',
    vibe: 'Mécanisme au centre, fond ardoise clair',
    Component: FicheFlowchart,
  },
  {
    id: 'minimaliste',
    label: 'Minimaliste',
    vibe: 'Exam-cram noir & blanc, prêt à imprimer',
    Component: FicheMinimaliste,
  },
];

export function getTemplate(id: TemplateId): TemplateMeta {
  return TEMPLATES.find((t) => t.id === id) ?? TEMPLATES[0]!;
}
